export const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS'
export const GET_TOTAL_SUCCESS = 'GET_TOTAL_SUCCESS'